export const SET_USER_LOCATION_VALUE = 'src/store/userLocation/SET_USER_LOCATION_VALUE';
